import { createLucideIcon } from "lucide-react";

export const ArrowDataTransferSquare = createLucideIcon(
    "ArrowDataTransferSquare",
    [
        [
            "path",
            {
                d: "M14.1316 16L16.5 14H7.9737",
                key: "slqr0w",
            },
        ],
        [
            "path",
            {
                d: "M16.5 10H7.5L10.3421 8",
                key: "1x185e",
            },
        ],
        [
            "path",
            {
                d: "M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z",
                key: "1c3crg",
            },
        ],
    ],
);
